import { createApiConfig } from '@modules/api-config'

const { apiConfig, API_BASE_URL, AUTH_API_URL } = createApiConfig('publisher')

const SHARE_API_BASE_URL = API_BASE_URL.replace(/\/publisher(\/|$)/, '/share$1')
const SHARE_ANALYTICS_URL = `${SHARE_API_BASE_URL}/event/log`

export { apiConfig, API_BASE_URL, AUTH_API_URL, SHARE_API_BASE_URL, SHARE_ANALYTICS_URL }
